const H2 = ({ children }) => (
    <h2 style={{ fontSize: '28rem', lineHeight: 1.3, textAlign: 'center' }}>{ children }</h2>
)

export default H2